import React from "react";
import * as TyCode from "../../../../../common-deprecated/styles/v2/toyota/custom/TyCode";
import { ImageFluid } from "../../../../../common-deprecated/styles/v2/toyota/globals/Image";
import useConfigCode from "../../hooks/summary/useConfigCode";
import { BnbLabel } from "../../utils/labels";
import Smartphone from "../../../../../common-deprecated/svg/toyota/aem/smartphone.svg";
import CarVisual from "../../../../../common-deprecated/svg/toyota/aem/carVisual.svg";
import * as Type from "../../../../../common-deprecated/styles/v2/toyota/globals/Type";

const TyCodeBlock = (): JSX.Element | null => {
    const { qrCode, code, error, showSaving } = useConfigCode();
    if (error) return null;

    return (
        <TyCode.Wrapper>
            <TyCode.QrCode>
                {showSaving ? (
                    <Type.SmallHeading>
                        <BnbLabel label="savingConfig" />
                    </Type.SmallHeading>
                ) : (
                    <>
                        <ImageFluid src={qrCode} alt="Toyota config qr code" />
                        <TyCode.Label>tme.one/{code}</TyCode.Label>
                    </>
                )}
            </TyCode.QrCode>
            <TyCode.Cards>
                <TyCode.InfoCard data-testid="info-card">
                    <TyCode.Icons>
                        <TyCode.NumberIcon>1</TyCode.NumberIcon>
                        <TyCode.SvgWrapper>
                            <Smartphone width={80} height={80} />
                        </TyCode.SvgWrapper>
                    </TyCode.Icons>
                    <TyCode.Title>
                        <BnbLabel label="yourCodeStep1Title" />
                    </TyCode.Title>
                    <BnbLabel label="yourCodeStep1Description" />
                </TyCode.InfoCard>
                <TyCode.InfoCard>
                    <TyCode.Icons>
                        <TyCode.NumberIcon>2</TyCode.NumberIcon>
                        <TyCode.SvgWrapper>
                            <CarVisual viewBox="0 0 80 80" width={80} height={80} />
                        </TyCode.SvgWrapper>
                    </TyCode.Icons>
                    <TyCode.Title>
                        <BnbLabel label="yourCodeStep2Title" />
                    </TyCode.Title>
                    <BnbLabel label="yourCodeStep2Description" />
                </TyCode.InfoCard>
            </TyCode.Cards>
        </TyCode.Wrapper>
    );
};

export default TyCodeBlock;
